module.exports = __webpack_public_path__ + "media/media/cases/done-1-a90a11bc166a03cff5a4b77dce2bb0f0.jpg";